//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { CollectionListModel } from './CollectionListModel';
  
  export class ModuleListModel extends ModelBase {
      static readonly $typeName = 'ModuleListModel';
      public moduleDisplayName: string;
      public moduleName: string;
      public ruleCollections: CollectionListModel[];
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/ModuleListModel.ts